import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { usersStore, type UsersStoreState } from './UsersStore';
import { selectData, selectById, selectIsLoading } from '../selectors.ts';

import { useAttach } from '../useAttach';

export function useUsersData() {
  useAttach(usersStore, 'useUsersData');

  return useStoreWithEqualityFn(usersStore.store, selectData, shallow);
}
useUsersData.store = usersStore;

export function useUsersById() {
  useAttach(usersStore, 'useUsersById');

  return useStoreWithEqualityFn(usersStore.store, selectById, shallow);
}
useUsersById.store = usersStore;

export function useUser({ userId }: { userId: string }) {
  useAttach(usersStore, 'useUser');

  const select = useCallback(
    (state: UsersStoreState) => {
      return {
        user: state.byId?.[userId] ?? null,
        userInstance: state.data?.[userId] ?? null,
      };
    },
    [userId]
  );

  return useStoreWithEqualityFn(usersStore.store, select, shallow);
}
useUser.store = usersStore;

export function useUsersAttach() {
  useAttach(usersStore, 'useUsersAttach');
}
useUsersAttach.store = usersStore;

export function useUsersLoading() {
  useAttach(usersStore, 'useUsersLoading');
  return useStoreWithEqualityFn(usersStore.store, selectIsLoading, Object.is);
}
useUsersLoading.store = usersStore;
